import React, { useCallback, useRef, useState, useEffect } from 'react'
import { useAppSelector } from '../store/hooks';
import { VideoProps } from '../types/typedeclaration';
import { Videobox } from '../components/Videobox';
import { useSwipe } from '../store/useSwipe';
import fetchData from 'Utilis/request';
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const Videos = () => {
    const { onTouchStart, onTouchMove, onTouchEnd } = useSwipe();
  const newsContainerRef = useRef<HTMLDivElement>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const [videos, setVideos] = useState<VideoProps[]>([]);
  const [offset, setOffset] = useState(0);
  const [hasMore, setHasMore] = useState(true);
  const darkMode = useAppSelector((state: any) => state.categoryNavigation.darkmode);
  const fontSize = useAppSelector((state: any) => state.categoryNavigation.fontsize);
  const headerHeight = useAppSelector((state: any) => state.categoryNavigation.headerHeight || 0);

  // Fetch initial videos
  useEffect(() => {
    fetchVideos(0);
  }, []);

  const fetchVideos = async (increament: number) => {
    if (loading || !hasMore) return;    
    setLoading(true);
    try {      
       const vidData = await fetchData.getResult(`${API_BASE_URL}getArticleByCat.php?slug=${"video"}&start=${increament}`);  
       
      const items = vidData?.articles || [];
      if (vidData?.status == true) {
         setVideos(prev => increament === 0 ? items : [...prev, ...items]);
        setOffset(increament + 20);       
      } else {
        setHasMore(false);
      }
    } catch (error) {
      console.error("Error fetching videos:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleScroll = useCallback(async () => {
    if (!shouldFetchMore() || loading || !hasMore) return;
    await fetchVideos(offset);    
  }, [offset, loading, hasMore]);

  const shouldFetchMore = () => {
    if (!newsContainerRef.current) return false;
    const { scrollTop, scrollHeight, clientHeight } = newsContainerRef.current;
    return scrollTop + clientHeight >= scrollHeight - 100;
  };

  return (
    <div className={`font-sans min-h-screen ${darkMode ? 'bg-gray-900 text-white' : 'bg-gray-100 text-gray-900'}`}>
      <main
        className="pb-20 px-3 video-container"
        ref={newsContainerRef}
        onScroll={handleScroll}
        style={{ height: `calc(100vh - ${headerHeight}px)`, overflowY: 'auto', paddingTop:headerHeight+15 }}
       onTouchStart={onTouchStart}
        onTouchMove={onTouchMove}
        onTouchEnd={onTouchEnd}>        
        <div className="news-container">
          <Videobox
            darkMode={darkMode}
            fontSize={fontSize}
            videos={videos}               
            inlineView={true}
          />
          {loading && <div className="text-center py-4">Loading more videos...</div>}
          {!hasMore && <div className="text-center py-4">No more videos to load</div>}
        </div>
      </main>
    </div>
  )
}

export default Videos;